import { guard } from '@/utils';
import {
  CreateTaskGroupDto,
  TaskGroupDto,
  UpdateTaskGroupDto,
} from './taskGroupsTypes';
import { Http } from '../http';

class TaskGroupsHttp extends Http {
  public async create(request: CreateTaskGroupDto) {
    guard.notNull(request, 'request');
    const response = await this._axios.post<string>(`/api/task-group`, request);
    return response.data;
  }

  public async update(request: UpdateTaskGroupDto) {
    guard.notNull(request, 'request');
    const response = await this._axios.put<string>(`/api/task-group`, request);
    return response.data;
  }

  public async ungroup(request: { groupId: string }) {
    guard.notNull(request, 'request');
    const response = await this._axios.put<string>(
      `/api/task-group/ungroup`,
      request,
    );
    return response.data;
  }

  public async get(id: string) {
    guard.notNull(id, 'id');
    const response = await this._axios.get<TaskGroupDto>(
      `/api/task-group/${id}`,
    );
    return response.data;
  }

  public async getAll(projectId: string) {
    guard.notNull(projectId, 'id');
    const response = await this._axios.get<TaskGroupDto[]>(
      `/api/task-group?projectId=${projectId}`,
    );
    return response.data;
  }
}

export const taskGroupsHttp = new TaskGroupsHttp();
